import { render, staticRenderFns } from "./AppHeaderTos.vue?vue&type=template&id=824e9a06&scoped=true"
import script from "./AppHeaderTos.vue?vue&type=script&lang=js"
export * from "./AppHeaderTos.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderTos.vue?vue&type=style&index=0&id=824e9a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824e9a06",
  null
  
)

export default component.exports